// extracted by mini-css-extract-plugin
export const top = "TopPost-module--top--3Xe4O";
export const cover = "TopPost-module--cover--36Uv8";